module.exports = __webpack_public_path__ + "c0ce57f1814fb58081f20dd640da2990.pdf";